// extracted by mini-css-extract-plugin
export default {"confirmedLabel":"DirectionsPage-module__confirmedLabel--CDt9W","confirmedIcon":"DirectionsPage-module__confirmedIcon--WcBWh"};